import { useEffect, useState } from "react";
import { IStakeInfo } from "../../utils/types";
import StakeInfoForm from "./StakeInfoForm";
import { toast } from "react-toastify";
import { apiServices } from "../../utils/apiServices";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
import { useTheme } from "../../context/ThemeContext";
import { SN_VAL_ADDRS } from "../../utils/const";
import { IAutoStakeResponse } from "../../utils/types";
import AutoStakeListTable from "./AutoStakeListTable";
import clsx from "clsx";
import { CheckedIcon } from "../SVGIcons";
import Input from "../Input";

const Checkbox = ({ label, isChecked, onChange }: { label: string, isChecked: boolean, onChange: () => void }) => {
  const { isDark } = useTheme();
  return <div className="flex items-center gap-[8px] cursor-pointer" onClick={() => onChange()}>
    <div className="min-w-[24px] h-[24px] flex items-center justify-center">
      {isChecked ? <CheckedIcon fillColor={isDark ? "white" : "black"} /> : <div className="w-[20px] h-[20px] rounded-full border-[2px] border-black dark:border-white" />}
    </div>
    <label className="text-[14px] text-black dark:text-white select-none cursor-pointer truncate">{label}</label>
  </div>
}


const TraderAutoStakingTab = ({ subnetId, stakeAmount, setSubnetId, setStakeAmount }: IStakeInfo) => {
  const { id } = useParams<{ id: string }>();
  const [repeatCount, setRepeatCount] = useState<number>(-1);
  const [isRepeating, setIsRepeating] = useState<boolean>(false);
  const [stakePrice, setStakePrice] = useState<string>('');
  const [unstakePrice, setUnstakePrice] = useState<string>('');
  const { activeAccount } = useAppContext();
  const [autoStakes, setAutoStakes] = useState<IAutoStakeResponse[]>([]);

  const getAutoStakes = async () => {
    if (!activeAccount?.address) {
      return;
    }
    try {
      const res = await apiServices.stakes.getAutoStakes(activeAccount?.address || '');
      setAutoStakes(res);
    } catch (error) {
      console.error('Error fetching auto stakes:', error);
      toast.error('Error fetching auto stakes');
    }
  }

  const stopAutoStake = async (stakeId: number) => {
    // if (!activeAccount?.address) {
    //   toast.error('Error: active account is not defined');
    //   return;
    // }
    // const signature = localStorage.getItem(activeAccount?.address || '');
    // if (!signature) {
    //   toast.error('Error: Signature is not defined');
    //   return;
    // }
    // try {
    //   const res = await apiServices.stakes.stopAutoStake(stakeId, activeAccount?.address || '', signature);
    //   if (res.auto_stake_id === stakeId) {
    //     toast.success('Auto stake stopped successfully!');
    //     getAutoStakes(); // Refresh the list after stopping
    //   } else {
    //     toast.error('Error: Failed to stop auto stake');
    //   }
    // } catch (error) {
    //   console.error('Error stopping auto stake:', error);
    //   toast.error('Error stopping auto stake');
    // }
  }

  // useEffect(() => {
  //   getAutoStakes()
  // }, [activeAccount?.address]);

  const { theme } = useTheme();
  const handleAutoStake = async () => {
    toast.info("Auto Staking function will be available from the next version.");
    // if (!activeAccount?.address) {
    //   toast.error('Error: active account is not defined');
    //   return;
    // }
    // const signature = localStorage.getItem(activeAccount?.address || '');
    // if (!signature) {
    //   toast.error('Error: Signature is not defined');
    //   return;
    // }
    // apiServices.stakes.autoStake({
    //   trader_id: activeAccount?.address || '',
    //   subnet: Number(subnetId),
    //   val_addr: SN_VAL_ADDRS[Number(subnetId)] || '',
    //   stake_amount: Number(stakeAmount),
    //   stake_price: Number(stakePrice),
    //   unstake_price: Number(unstakePrice),
    //   repeat_cnt: isRepeating ? -1 : repeatCount,
    // }, signature).then((res: any) => {
    //   if (res.auto_stake_id) {
    //     toast.success('Auto staking started!');
    //     getAutoStakes();
    //   } else {
    //     toast.error('Error: Auto staking failed!');
    //   }
    // })
  }
  const inputClsName = `w-full px-3 py-2 rounded-md ${theme === 'dark' ? 'dark' : ''} bg-black/10 dark:bg-white/10 text-[14px] text-black dark:text-white`

  return (
    <div className="space-y-6">
      <div >
        <StakeInfoForm subnetId={subnetId} setSubnetId={setSubnetId} stakeAmount={stakeAmount} setStakeAmount={setStakeAmount} />
        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label htmlFor="stakePrice" className="block text-sm font-medium text-black dark:text-white mb-2">Stake Price</label>
            <Input
              props={{
                type: "number",
                id: "stakePrice",
                value: stakePrice,
                onChange: (e) => setStakePrice(e.target.value),
                placeholder: "Enter stake price",
                min: "0",
                step: "0.01"
              }}
              className={inputClsName}
            />
          </div>
          <div>
            <label htmlFor="unstakePrice" className="block text-sm font-medium text-black dark:text-white mb-2">
              Unstake Price
            </label>
            <Input
              props={{
                type: "number",
                id: "unstakePrice",
                value: unstakePrice,
                onChange: (e) => setUnstakePrice(e.target.value),
                placeholder: "Enter unstake price",
                min: "0",
                step: "0.01"
              }}
              className={inputClsName}
            />
          </div>
        </div>
        <div className="flex items-center space-x-8 mt-4">
          <div className="flex items-center space-x-4">
            <Checkbox label="Repeat Times" isChecked={!isRepeating} onChange={() => setIsRepeating(false)} />

            <Input
              props={{
                type: "number",
                value: repeatCount,
                onChange: (e) => setRepeatCount(Number(e.target.value)),
                placeholder: "N",
                min: "1"
              }}
              className={clsx(inputClsName, "!w-[50px]")}
            />
          </div>
          <Checkbox label="Repeat until stopped" isChecked={isRepeating} onChange={() => setIsRepeating(true)} />

        </div>

      </div>
      <div className="flex justify-end gap-4">
        <button
          onClick={handleAutoStake}
          disabled={!subnetId || !stakeAmount || Number(stakeAmount) <= 0 || (!isRepeating && !repeatCount) || Number(stakePrice) <= 0 || Number(unstakePrice) <= 0}
          className="py-2 bg-[#00FFEE] text-white dark:text-black rounded-[100px] hover:opacity-80 transition-all duration-200 text-[14px] h-[46px] px-[42px] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Start
        </button>
      </div>
      <AutoStakeListTable
        autoStakes={autoStakes}
        stopAutoStake={stopAutoStake}
      />
    </div>
  );
};

export default TraderAutoStakingTab;
